import {
  Component,
  Input,
  OnInit
} from '@angular/core';

import { BlockUI, NgBlockUI }            from 'ng-block-ui';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { EditorTokenModel }  from './typings/my-workshop.editor-token';
import { MyWorkshopService } from './my-workshop.service';
import { MessagesService } from '../messages/messages.service';

@Component({
  selector   : 'wor-my-workshop-frame',
  template: require('./my-workshop.frame.component.html')
})
export class MyWorkshopFrameComponent implements OnInit {
  @BlockUI('myWorkshopFrameBlock') block : NgBlockUI;

  @Input() set url ( _url: string ) {
    this._url = this.sanitizer.bypassSecurityTrustUrl(_url);
  };

  _url  : SafeResourceUrl | null = null;

  constructor (
    private messagesService  : MessagesService,
    private myWorkshopService: MyWorkshopService,
    private sanitizer        : DomSanitizer
  ) {}

  ngOnInit () : void {
    this.loadEditorToken();
  }

  loadEditorToken () : void {
    this.block.start();

    this.myWorkshopService.getEditorToken()
    .then(( token : EditorTokenModel ) => {
      this._url = this.sanitizer.bypassSecurityTrustResourceUrl(token.editor_url);
    })
    .catch(err => this.messagesService.error(err))
    .finally(() => this.block.stop());
  }
}
